<label class="form-label" [ngClass]="labelClass" [attr.for]="labelFor">{{ this.label }}</label>
<div [ngClass]="inputWrapperClass"><ng-content></ng-content></div>
<small
  *ngIf="hasError && errorMessage"
  data-cy="error-message"
  [ngClass]="errorMessageClass"
  [innerHTML]="errorMessage"
></small>
